import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { TranslocoModule } from '@ngneat/transloco';

import { LastSyncResultsButtonComponent } from './last-sync-results-button.component';
import { ProjectsSyncResultsModalComponent } from '../projects-sync-results-modal/projects-sync-results-modal.component';
import { P6SyncResultsModalComponent } from '../p6-sync-results-modal/p6-sync-results-modal.component';
import { ObservationsSyncResultsModalComponent } from '../observations-sync-results-modal/observations-sync-results-modal.component';

@NgModule({
  declarations: [
    LastSyncResultsButtonComponent,
    ProjectsSyncResultsModalComponent,
    P6SyncResultsModalComponent,
    ObservationsSyncResultsModalComponent,
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    MatProgressBarModule,
    TranslocoModule,
  ],
  exports: [
    LastSyncResultsButtonComponent,
    ProjectsSyncResultsModalComponent,
    P6SyncResultsModalComponent,
    ObservationsSyncResultsModalComponent,
  ],
})
export class LastSyncResultsButtonModule {}
